import { LINKED_REGISTER, PRODUCT_CODE, PRODUCT_TYPE } from "@utils/enums";
import { useApiOriginacao } from "./base/useApiOriginacao";

export type IApiAuthTokenData =
  | {
      identifier: string;
      password: string;
    }
  | {
      encrypted_key: string;
      iv: string;
      data: string;
    };

type IApiAuthTokenResponse = {
  access: string;
  refresh: string;
  change_password: boolean;
  detail: string;
  reset_token: string;
  mfa_enabled: boolean;
  email: string;
};

export type IApiAuthPermissoesUsuarioResponse = {
  check_url?: string;
  corban: {
    id: number;
    corban_name: string;
    is_active: boolean;
    permite_analfabeto: boolean;
    permite_representante: boolean;
    permite_representante_cartao: boolean;
  };
  date_joined: string;
  device_id: unknown | null;
  enable_face_match: boolean;
  groups: unknown[];
  id: number;
  identifier: string;
  is_active: boolean;
  permite_multiprodutos: boolean;
  is_checked?: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  last_login: unknown | null;
  name: string;
  permissions: string[];
  produtos: Array<{
    ativo: boolean;
    cd_produto: PRODUCT_CODE;
    nome: string;
  }>;
  unique_id: string;
  possui_chat_suporte: boolean;
  termo_uso_privacidade: boolean;
  cadastro_validation: {
    is_linked: boolean;
    formalization_url?: string;
    status_label?: LINKED_REGISTER;
  };
};

type IApiAuthSolicitarNovaSenhaData = {
  email: string;
};

type IApiAuthSolicitarNovaSenhaResponse = {
  flEnviadoComSucesso: boolean;
  dsMensagemRetorno: string;
};

type IApiAuthAtualizarSenhaData = {
  senhaAtual: string;
  senhaNova: string;
};

type IApiAuthRedefinirSenhaData = {
  password: string;
};

type IApiAuthAtualizarSenhaResponse = {
  retorno: string;
  senhaAtualInvalida: boolean;
  senhaNovaInvalida: boolean;
  senhaNovaInvalidaListaErros: unknown[] | null;
};

export type IApiCorbansResponse = {
  count: number;
  next: null;
  previous: null;
  results: Array<{
    id: number;
    corban_name: string;
    fantasy_name: string;
    url: string | null;
    produtos: Array<{
      nome: string;
      tipo_produto: PRODUCT_TYPE;
    }>;
  }>;
};

type IApiAuthSelectCorbanResponse = {
  access: string;
  refresh: string;
};

type IApiAuthSelectCorbanData = {
  id: number;
};

type IApiAuthPublicKeyResponse = {
  public_key: string;
};

export const useApiAuthPublicKey = () => {
  return useApiOriginacao<IApiAuthPublicKeyResponse>({
    method: "GET",
    url: "/auth/public-key/",
  });
};

export const useApiAuthToken = () => {
  return useApiOriginacao<IApiAuthTokenResponse, IApiAuthTokenData>({
    method: "POST",
    url: "/auth/token/",
  });
};

export const useApiAuthPermissoesUsuario = () => {
  return useApiOriginacao<IApiAuthPermissoesUsuarioResponse>({
    method: "GET",
    url: "/auth/permissoes-usuario/",
  });
};

export const useApiAuthSolicitarNovaSenha = () => {
  return useApiOriginacao<
    IApiAuthSolicitarNovaSenhaResponse,
    IApiAuthSolicitarNovaSenhaData
  >(
    {
      method: "POST",
      url: "/auth/password-request-reset/",
    },
    {
      defaultErrorMessage: "Por Favor digite o seu e-mail corretamente!",
    },
  );
};

export const useApiAuthAtualizarSenha = () => {
  return useApiOriginacao<
    IApiAuthAtualizarSenhaResponse,
    IApiAuthAtualizarSenhaData
  >({
    method: "POST",
    url: "/auth/atualizar-senha",
  });
};

export const useApiAuthRedefinirSenha = () => {
  return useApiOriginacao<IApiAuthRedefinirSenhaData>({
    method: "POST",
  });
};

export const useApiCorbans = () => {
  return useApiOriginacao<IApiCorbansResponse>({
    method: "GET",
    url: "/corbans/",
  });
};

export const useApiAuthSelectCorban = () => {
  return useApiOriginacao<
    IApiAuthSelectCorbanResponse,
    IApiAuthSelectCorbanData
  >({
    method: "POST",
    url: "/auth/select-corban/",
  });
};
